module.exports = __webpack_public_path__ + "static/media/speakers_logos_GUT.9be253e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_GUT.jpg
// module id = 266
// module chunks = 0